/* Build a screen's "working game": the authoritative server state with the
 * staged decision overlay applied on top, computed with the engine's OWN
 * mutators through the same applyDecisions the server runs at advance
 * (packages/engine/src/apply.js) — so what the student previews is, by
 * construction, what the server will resolve. Pure + cheap, so it can be
 * recomputed on every keystroke for live feedback. */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { applyDecisions } from '@venturewrist/engine';
import { NEW_PRODUCT_ID_PREFIX, newProductIndex } from '@venturewrist/shared';
import type { RoundDecisions } from '@venturewrist/shared';

/** Prefix marking a working-game product that originates from a staged
 *  newProducts[idx] entry (not yet a real server product). The server resolves
 *  the same ids onto the products it creates from the same bundle. */
export const NEW_PREFIX = NEW_PRODUCT_ID_PREFIX;
export { newProductIndex };

export function buildWorkingGame(base: any, draft: RoundDecisions): any {
  const g = structuredClone(base);
  applyDecisions(g, draft, { preview: true });
  return g;
}
